import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../campaigns/assets/images/ball-title.svg'
import _imports_1 from '@/assets/images/copy-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-1327130a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "p-grid p-col-12 p-flex-column p-align-center",
  style: {"margin-top":"1px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "ball",
    src: _imports_0
  })
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "paragrah-link" }, "Paste this link to your content in your channels to have access to insights and track progress. ", -1))
const _hoisted_6 = {
  key: 1,
  class: "link p-d-flex"
}
const _hoisted_7 = { class: "link-bold eclipsis" }
const _hoisted_8 = {
  key: 2,
  class: "link p-d-flex"
}
const _hoisted_9 = { class: "link-bold eclipsis" }
const _hoisted_10 = {
  key: 3,
  class: "agreement p-d-flex p-align-center"
}
const _hoisted_11 = {
  for: "agreement",
  class: "p-ml-2 p-mt-4 p-d-flex p-align-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toltip_info = _resolveComponent("toltip-info")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Terms = _resolveComponent("Terms")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.user?.isCreator() || _ctx.user?.isAgencyOwner())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (!_ctx.findConditionInCampaignTerms(_ctx.contractHasCreatorAndSetChannel, _ctx.contract as CampaignData) 
      && !_ctx.findConditionInCampaignTerms(_ctx.contractMatchesChannel, _ctx.contract as CampaignData))
            ? (_openBlock(), _createElementBlock("h4", _hoisted_3, " Request influencer link and Gamekeys"))
            : (_openBlock(), _createElementBlock("h3", _hoisted_4, "Your influencer link and Gamekeys"))
        ], 64))
      : _createCommentVNode("", true),
    _hoisted_5,
    (_ctx.findConditionInCampaignTerms(_ctx.contractHasCreatorAndSetChannel, _ctx.contract as CampaignData)  || _ctx.agree)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_toltip_info, null, {
            body: _withCtx(() => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.trackingLink), 1),
              _createElementVNode("img", {
                src: _imports_1,
                class: "p-ml-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.copyLink(_ctx.trackingLink)))
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.contract?.gamekeys && _ctx.findConditionInCampaignTerms(_ctx.contractHasCreatorAndSetChannel, _ctx.contract as CampaignData) ||
     _ctx.agree && _ctx.contract?.gamekeys)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.contract?.gamekeys), 1),
          _createElementVNode("img", {
            src: _imports_1,
            class: "p-ml-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyLink(_ctx.contract?.gamekeys)))
          })
        ]))
      : _createCommentVNode("", true),
    (!_ctx.findConditionInCampaignTerms(_ctx.contractHasCreatorAndSetChannel, _ctx.contract as CampaignData) && !_ctx.agree)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(_component_Checkbox, {
            id: "agreement",
            modelValue: _ctx.acceptedTerms,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.acceptedTerms) = $event)),
            binary: true,
            class: "p-mt-4 agreement-checkbox"
          }, null, 8, ["modelValue"]),
          _createElementVNode("label", _hoisted_11, [
            _createTextVNode(" I agree with the "),
            _createElementVNode("span", {
              class: "p-mr-1 p-ml-1 term-and-conditions p-d-flex",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTerms = true))
            }, "Terms and Conditions"),
            _createTextVNode(" for this Campaign ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Terms, {
      "show-modal": _ctx.showTerms,
      onCloseTerms: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showTerms = false))
    }, null, 8, ["show-modal"]),
    (!_ctx.findConditionInCampaignTerms(_ctx.contractHasCreatorAndSetChannel, _ctx.contract as CampaignData)  && !_ctx.agree)
      ? (_openBlock(), _createBlock(_component_Button, {
          key: 4,
          label: "Request",
          disabled: !_ctx.acceptedTerms,
          onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.campaignModule.manager.agreeTerms(_ctx.contract?.id, _ctx.contract?.contracts
               && _ctx.contract.contracts.length ? _ctx.contract?.contracts[0]?.channel : undefined); _ctx.agree = true;}),
          class: "white-button p-mt-5"
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}